<span class="circle" [class]="circleProductState"></span>
<span class="label" [class]="labelProductState">{{
  record | prettyProductState
}}</span>
